// @flow

import React from 'react';
import type { FieldProps } from '../../../types';
import Hidden from './hidden';

type Props = FieldProps;

export default ({
  input,
}: Props) => (
  <Hidden {...input} />
);
